import { pgTable, uuid, text, numeric, timestamp, index, integer, uniqueIndex, } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
export const computeUsage = pgTable("compute_usage", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    runId: text("run_id").notNull(),
    taskId: text("task_id").notNull(),
    resourceId: uuid("resource_id"),
    triggerCostCents: numeric("trigger_cost_cents", { precision: 10, scale: 4 }).notNull(),
    lucienCostCents: numeric("lucien_cost_cents", { precision: 10, scale: 4 }),
    durationMs: integer("duration_ms"),
    status: text("status").notNull(),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
}, table => ({
    runIdUnique: uniqueIndex("compute_usage_run_id_unique").on(table.runId),
    companyCreatedIdx: index("compute_usage_company_created_idx").on(table.companyId, table.createdAt),
}));
